import { Component, OnInit, ViewChild } from '@angular/core';

import { MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { ApiService } from  'src/app/services/api';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Header, Trace,EventMonitoring,SystemInfo } from '../models/trace.model';  // Import the interfaces
import { MatSelectModule } from '@angular/material/select';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink} from '@angular/router';

@Component({
    selector: 'search-table',
    imports: [
    MatTableModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule,
    MatButtonModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule,  
    MatIconModule,
    RouterLink
],
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.css']
})

export class EventsComponent implements OnInit {

  events : EventMonitoring[] = [];
  loading = false;
  noDataFound = false;
  error:any | null = null;
  displayedColumns: string[] = ['event', 'producers', 'consumers','update'];

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadEvents();
  }

  loadEvents():void{
    this.loading = true;
    this.apiService.getAllEventsWithSystems().subscribe({
        next: (data) => {
          console.log(data); // Assign the data to dataSource
          if(data == null) 
          {
             this.noDataFound = true;
          } 
          else 
          {
            this.events = [];
             for (const eventMonitoring  of data) 
             {
               this.events.push(eventMonitoring);
             }            
          }
          this.loading = false; },
        error: (message) => {
          console.error(message);
          this.loading = false;
          // General error handling
          this.error = {
            message: 'Failed to fetch logs from the server.',
            details: message || 'Unknown error occurred.'       
          };
        }
      });
  }  
}